import React, { useContext } from 'react';
import GeneralContext from '../../context/GeneralContext'
import styles from './ContratanteNatural.module.css'

import Identificacion from '../Identificacion'
import Contacto from '../Contacto'
import DatosPersonales from '../DatosPersonales'
import Laboral from '../Laboral'
import Adicionales from '../Adicionales/Adicionales'

const ContratanteNatural = ({ contratante, state, setState, respuesta, modal }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    return (
        <React.Fragment>
            <div className={styles['areaduocard']}>
                <Identificacion
                    contratante={contratante}
                    state={state}
                    setState={setState}
                    mostrarPopup={modal}
                />
                <Contacto
                    contratante={contratante}
                    state={state}
                    setState={setState} />
            </div>

            <DatosPersonales
                contratante={contratante}
                state={state}
                setState={setState} />

            <Laboral
                contratante={contratante}
                state={state}
                setState={setState} />

            {cotizacion.esDistintoAsegurado && cotizacion.flagDeclaJurada
                && <Adicionales
                    state={state}
                    setState={setState}
                    paginaActual={'contratante'} />
            }
        </React.Fragment>
    )
}

export default ContratanteNatural;